// extracted by mini-css-extract-plugin
export default {"section":"Section_section__Z2PLw","header":"Section_header__mpTaY","toggle":"Section_toggle__YvReK","grid":"Section_grid__pI9fA"};